import { useTranslator } from '@bluebeam/react-i18n';
import Label from 'components/inputs/Label';
import StatusSelect from 'components/inputs/StatusSelect';
import Immutable from 'immutable';
import React, { FC } from 'react';
import { Project } from 'records/Project';
import { Punch, PunchStatusValue } from 'records/Punch';

interface Props {
  status: PunchStatusValue | null;
  updatedFields: Immutable.Set<string>;
  project: Project;
  actualPunches: Immutable.Set<Punch>;
  onChange: (v: any) => void;
}
const Status: FC<Props> = ({ status, project, actualPunches, onChange }) => {
  const { translate } = useTranslator([
    'updateMultiplePunchOverlay',
    'statusLabels',
  ]);
  const allSameStatuses = (): boolean => {
    return actualPunches
      .flatMap((p) => p.status)
      .every((p) => p === actualPunches.first<Punch>().status);
  };

  const getStatusText = (): string => {
    const hasSameStatuses = project.statuses.some((v) => {
      return actualPunches.every((p) => p.status === v.status);
    });

    const { status } = actualPunches.first<Punch>(new Punch());
    const statusType: `${string}:${string}` =
      `statusLabels:statuses.${status}` as `${string}:${string}`;

    return hasSameStatuses
      ? translate(statusType)
      : translate('updateMultiplePunchOverlay:multiple');
  };

  return (
    <div className="grow-1 w100 mr3">
      <Label label={translate('updateMultiplePunchOverlay:status')} />
      <>
        <StatusSelect
          id="update-multi-punch-overlay-status"
          value={
            status != null
              ? status
              : allSameStatuses()
              ? getStatusText()
              : 'multiple'
          }
          onChange={onChange}
          placeholder={getStatusText()}
        />
      </>
    </div>
  );
};

export default Status;
